import _ from 'lodash';
import EventGroupViewModel from './EventGroupViewModel';

const GROUPS = [
  {
    key: 'celebrations',
    types: ['birthday', 'anniversary', 'first_day'],
    titleId: 'hr_dashboard.whats_going_on.CELEBRATIONS',
    pillStyle: 'celebration',
    emojiKey: 'tada',
    thresholds: {today: 8, upcoming: 2}
  },
  {
    key: 'peopleAway',
    types: ['time_off_request'],
    titleId: 'hr_dashboard.whats_going_on.PEOPLE_AWAY',
    pillStyle: 'timeOff',
    thresholds: {today: 8, upcoming: 2}
  },
  {
    key: 'holidays',
    types: ['holiday'],
    titleId: 'hr_dashboard.whats_going_on.HOLIDAYS',
    pillStyle: 'holiday',
    thresholds: {today: 8, upcoming: 2}
  }
];

const GROUPS_BY_KEY = _.keyBy(GROUPS, 'key');

const GROUP_KEYS_BY_TYPE = _.chain(GROUPS)
  .flatMap(group => group.types.map(type => [type, group.key]))
  .fromPairs()
  .value();

export function groupKeyFor(type) {
  return GROUP_KEYS_BY_TYPE[type];
}

function collapsedGroupKeys(events, scope) {
  return _.chain(events)
    .groupBy('groupKey')
    .pickBy((groupedEvents, groupKey) =>
      _.has(GROUPS_BY_KEY, groupKey) && groupedEvents.length > GROUPS_BY_KEY[groupKey].thresholds[scope])
    .keys()
    .value();
}

export function buildRows(events, scope, keyPrefix) {
  const collapsedKeys = collapsedGroupKeys(events, scope);

  return _.reduce(events, (rows, event) => {
    if (!_.includes(collapsedKeys, event.groupKey)) {
      return [...rows, event];
    }

    const groupRow = _.find(rows, row => row.rowType === 'group' && row.groupKey === event.groupKey);
    if (groupRow) {
      groupRow.add(event);
      return rows;
    }

    const group = new EventGroupViewModel(GROUPS_BY_KEY[event.groupKey], `${keyPrefix}-${event.groupKey}`);
    group.add(event);

    return [...rows, group];
  }, []);
}
